export type DonationSuccessCreds = {
  donationId: string;
  access?: string;
  token?: string;
};

function storageKey(donationId: string) {
  return `donation_success_creds:${donationId}`;
}

export function getDonationSuccessCreds(
  donationId: string
): DonationSuccessCreds | null {
  if (typeof window === "undefined") return null;
  const raw = sessionStorage.getItem(storageKey(donationId));
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as DonationSuccessCreds;
    if (!parsed?.donationId || parsed.donationId !== donationId) return null;
    return {
      donationId: parsed.donationId,
      access: parsed.access || undefined,
      token: parsed.token || undefined,
    };
  } catch {
    return null;
  }
}

export function setDonationSuccessCreds(creds: DonationSuccessCreds): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(
    storageKey(creds.donationId),
    JSON.stringify({
      donationId: creds.donationId,
      access: creds.access || undefined,
      token: creds.token || undefined,
    })
  );
}

export function clearDonationSuccessCreds(donationId: string): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(storageKey(donationId));
}
